import script from "./SnapshotList.vue?vue&type=script&setup=true&lang=js"
export * from "./SnapshotList.vue?vue&type=script&setup=true&lang=js"

import "./SnapshotList.vue?vue&type=style&index=0&id=382d7b1f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-382d7b1f"]])

export default __exports__